const MainLayoutStyle = theme => ({
	wrapper: {
		position: "relative",
		top: "0",
		height: "100vh",
		"&:after": {
			display: "table",
			clear: "both",
			content: '" "'
		}
	},
	mainPanel: {
		transitionProperty: "top, bottom, width",
		transitionDuration: ".2s, .2s, .35s",
		transitionTimingFunction: "linear, linear, ease",
		[theme.breakpoints.up("md")]: {
			width: `calc(100% - ${theme.drawerWidth}px)`
		},
		overflow: "auto",
		position: "relative",
		float: "right",
		transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)",
		maxHeight: "100%",
		width: "100%",
		overflowScrolling: "touch",
		height: "100%"
	},
	content: {
		marginTop: "70px",
		minHeight: "calc(100vh - 200px)"
	},
	container: {
		...theme.containerFluid,
		paddingRight: "0px",
		paddingLeft: "0px"
	},
	map: {
		marginTop: "70px"
	},
	mainPanelSidebarMini: {
		[theme.breakpoints.up("md")]: {
			width: `calc(100% - ${theme.drawerMiniWidth}px)`
		}
	},
});

export default MainLayoutStyle;
